module.exports = __webpack_public_path__ + "img/ug515.9ffe441b.png";